//Library Imports
import { useState } from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import styled from "styled-components";

//Local Imports
import { Popover } from "antd";
import { removeOnClickBubble } from "utils";
import Search from "../../../assets/img/icons/ArticlePopover/lowerList/search.svg";
import List from "../../../assets/img/icons/ArticlePopover/lowerList/list.svg";
import Frame from "../../../assets/img/icons/ArticlePopover/lowerList/frame.svg";
import Delete from "../../../assets/img/icons/ArticlePopover/lowerList/Delete.svg";
import CreateAsset from "modules/Campaigns/CampaignAssets/Components/CreateAsset";
import InfoPopover from "./InfoPopover";

const PopupTitle = ({ campaignId, onClickAfter, handleVisibleChange, cloneCampaignHandler, hide }) => {
  const cloningInProgress = useSelector((state) => state.campaigns.cloningInProgress);

  const popoverText = "All draft emails and keywords will be cloned";
  return (
    <BlogMenuStylingGreen>
      <div className="BlogItemDropdown">
        <ul>
          <li
            className="d-flex align-items-center justify-content-between"
            onClick={(e) => {
              removeOnClickBubble(e);
            }}
          >
            <span className={`${cloningInProgress ? "disabled" : ""}`}>
              <strong
                onClick={(e) => {
                  removeOnClickBubble(e);
                  cloneCampaignHandler(hide);
                }}
              >
                Clone Campaign
              </strong>
              &nbsp;
              <div hidden={!cloningInProgress} className="spinner-border spinner-border-sm" role="status">
                <span className="sr-only"></span>
              </div>
            </span>
            <InfoPopover infoText={popoverText} width={150} height={90} />
          </li>
          <li
            className="d-flex align-items-center"
            onClick={(e) => {
              removeOnClickBubble(e);
            }}
          >
            <CreateAsset
              hideDynamic={true}
              campaignId={campaignId}
              onClickAfter={() => onClickAfter(true)}
              dropDownWidth="w-100"
              wrapperclass="dropdown-of-dropdown dropdown-for-inner-list"
              handleVisibleChange={handleVisibleChange}
            >
              <strong> Create New Email in Campaign</strong>
            </CreateAsset>
          </li>
        </ul>
      </div>
    </BlogMenuStylingGreen>
  );
};

const Content = ({ campaignId, index, deleteHandler, emailsCount, hide, showDeleteConfirmation, disableDelete }) => {
  const history = useHistory();
  const onSmartSourceClick = (e) => {
    removeOnClickBubble(e);
    history.push("/campaigns/content/source?campaign_id=" + campaignId);
  };
  const onContactsClick = (e) => {
    removeOnClickBubble(e);
    history.push("/campaigns/content/audience?campaign_id=" + campaignId);
  };
  const onAssetsClick = (e) => {
    removeOnClickBubble(e);
    history.push("/campaigns/content?campaign_id=" + campaignId);
  };
  return (
    <BlogMenuStyling>
      <div className="BlogItemDropdown">
        <ul>
          <li className="d-flex align-items-center" onClick={onSmartSourceClick}>
            <img className="margin-right-sm" src={Search} alt="icon" />
            <strong> View SmartSourced Content</strong>
          </li>

          <li className="d-flex align-items-center" onClick={onAssetsClick}>
            <img className="margin-right-sm" src={Frame} alt="icon" />
            <strong> View All Emails</strong>
          </li>
          <li className="d-flex align-items-center" onClick={onContactsClick}>
            <img className="margin-right-sm" src={List} alt="icon" />
            <strong> View Recipients and Lists</strong>
          </li>
          <li
            onClick={(e) => {
              removeOnClickBubble(e);
              if (disableDelete) return;
              deleteHandler(index, campaignId, emailsCount);
              showDeleteConfirmation();
              hide();
            }}
            className={`d-flex align-items-center ${disableDelete ? "delete-disabled" : ""}`}
          >
            <img className="margin-right-sm" src={Delete} alt="icon" />
            <strong> Delete</strong>
          </li>
        </ul>
      </div>
    </BlogMenuStyling>
  );
};

function MenuPopup(props) {
  const [visible, setVisible] = useState(false);
  const [createEmail, setCreateEmail] = useState(false);
  const {
    id,
    data,
    isFav,
    isCurated,
    campaignId,
    index,
    deleteHandler,
    assetId,
    assetIndex,
    assetDeleteHandler,
    emailsCount,
    showDeleteConfirmation,
    cloneCampaignHandler,
    disableDelete
  } = props;
  const hide = () => {
    setVisible(false);
  };

  const handleVisibleChange = (visible) => {
    setVisible(visible);
    if (createEmail) {
      document.body.style.height = "100%";
      setTimeout(() => {
        setCreateEmail(false);
      }, 500);
    }
  };

  const handleCreateCampaign = (value) => {
    setCreateEmail(value);
  };

  return (
    <Popover
      onClick={(e) => {
        removeOnClickBubble(e);
      }}
      overlayInnerStyle={{ borderRadius: 10 }}
      overlayClassName={`BlogPopover popover-radius overflow-fix Popover-share unique-class-menu ${createEmail ? "top-20000" : ""}`}
      placement="leftTop"
      visible={visible}
      title={
        <PopupTitle
          cloneCampaignHandler={cloneCampaignHandler}
          campaignId={props.campaignId}
          onClickAfter={handleCreateCampaign}
          handleVisibleChange={handleVisibleChange}
          hide={hide}
        />
      }
      getPopupContainer={() => document.querySelectorAll(".content-inner")[0]}
      content={
        <Content
          id={id}
          data={data}
          isFav={isFav}
          isCurated={isCurated}
          campaignId={campaignId}
          index={index}
          deleteHandler={deleteHandler}
          assetId={assetId}
          assetIndex={assetIndex}
          assetDeleteHandler={assetDeleteHandler}
          emailsCount={emailsCount}
          hide={hide}
          showDeleteConfirmation={showDeleteConfirmation}
          disableDelete={disableDelete}
        />
      }
      destroyTooltipOnHide={true}
      trigger="click"
      onVisibleChange={handleVisibleChange}
    >
      {props.children}
    </Popover>
  );
}

const BlogMenuStylingGreen = styled.div`
  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  ul li {
    font-family: "roboto_regular", sans-serif;
    font-size: 14px;
    color: #27ce0a;
    padding-top: 5px;
    padding-bottom: 5px;
  }
`;
const BlogMenuStyling = styled.div`
  ul li {
    font-family: "roboto_regular", sans-serif;
    font-size: 14px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .delete-disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export default MenuPopup;
